import React, { Fragment, useState, useEffect } from 'react';
import MainLayout from '../components/layouts/MainLayout';
import HotelDetail from '../components/views/hotels/HotelDetail';
import Spin from '../components/Spin';
import timezoneItems from '../assets/timezone.json';
import * as api from '../api';

const HotelDetailContainer = ({history}) => {
  const [ isLoading, setIsLoading ] = useState(false);
  const [ hotelUpdateItem, setHotelUpdateItem ] = useState({
    name: '',
    timezone: '',
    address: '',
    desc: '',
    pincodeDayTypeOffset: '',
    commonrooms: [],
  });

  const selectHotel = async () => {
    try {
      setIsLoading(true);
      const res = await api.selectHotel();
      setHotelUpdateItem({
        name: res.data.name,
        timezone: res.data.timezone,
        address: res.data.address,
        desc: res.data.desc,
        pincodeDayTypeOffset: res.data.pincode_day_type_offset,
        commonrooms: res.data.commonrooms,
      });
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    try {
      if (localStorage.getItem('hotel_id')) selectHotel();
    } catch (error) {
      throw error;
    }
  }, []);

  return (
    <Fragment>
      <Spin isSpin={isLoading}/>
      <MainLayout
        history={history}
        refresh={() => selectHotel()}
        ContentBody={(
          <HotelDetail
            hotelUpdateItem={hotelUpdateItem}
            timezoneItems={timezoneItems}
            history={history}
          />
        )}
      />
    </Fragment>
  );
}

export default HotelDetailContainer;